import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from "@angular/core";

import { PermissionsService } from "./../../../shared/services";
import { Task, Shift, PlanningActivity } from "../../../shared/types";
import { TaskRecordType } from "app/shared/enums";

@Component({
	selector: "ic-task-list",
	templateUrl: "./task-list.component.html",
	styleUrls: ["./task-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TaskListComponent {
	private readonly permissionsService = inject(PermissionsService);

	// @ts-expect-error TS2564
	@Input() tasks: { completed: Task[]; uncompleted: Task[] };
	// @ts-expect-error TS2564
	@Input() activities: PlanningActivity[];
	// @ts-expect-error TS2564
	@Input() shift: Shift;
	// @ts-expect-error TS2564
	@Input() loading: boolean;

	@Output() selectTask = new EventEmitter<Task>();
	@Output() create = new EventEmitter<void>();

	get isEmpty() {
		return !this.tasks || (this.tasks.uncompleted.length === 0 && this.tasks.completed.length === 0);
	}

	get isLoading() {
		return this.loading && !this.tasks && !this.activities;
	}

	canUpdateTask(task: Task) {
		if (task.recordType === TaskRecordType.WOUNDCARE) {
			return this.permissionsService.userHasPermissions(["MEDAPP.CARE.ADMINISTER_WOUNDCARE"]);
		} else {
			return this.permissionsService.userHasPermissions(["MEDAPP.CARE.ADMINISTER_CARE"]);
		}
	}
}
